define((require) => {
    "use strict";

    const ImprovedModel        = require("shared/zbone/ImprovedModel");
    const CompanyState         = require("shared/data/CompanyState");
    const Backbone             = require("backbone");
    const BreakpointCollection = require("shared/ui/breakpoint/BreakpointCollection");
    const RestApi              = require("shared/services/RestApi");

    /**
     * Company Settings Model.
     *
     * @class CompanySettings
     * @constructor
     */
    return ImprovedModel.extend("Company Settings", {

        /**
         * Returns the RestApi url path corresponding to this specific resource.
         *
         * @returns {String} the RestApi url path corresponding to this specific resource
         */
        url() {
            const id = this.get("id");

            if (id) {
                return RestApi.pathToSpecificResource(RestApi.Collections.SETTINGS, id); // for methods like fetch()
            }

            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, this.get("companyId"), RestApi.Collections.SETTINGS); // for load based on company
        },

        defaults: {
            googleAnalyticsId:        "",
            segmentIoApiKey:          "",
            analyticsEnabled:         true,
            companyId:                null,
            state:                    null,
            imageViewedEventsEnabled: false,
            templateSharingEnabled:   false,
            channelConfigId:          null,
            cloudinaryDefaultImageProvider: false,

            /**
             * Whether the breakpoint feature is enabled.
             *
             * @type {Boolean}
             */
            breakpointEnabled: false,

            /**
             * The company's default breakpoint "template".
             *
             * @type {BreakpointCollection}
             */
            breakpoints: [{threshold: 768}, {threshold: 992}]
        },

        relations: [{
            type: Backbone.Many,
            key: "breakpoints",
            collectionType: BreakpointCollection
        }],

        computed: {
            state: {
                deps: ["state"],
                // First a string name, secondarily the actual state...
                value: (state) => CompanyState.of(state)
            }
        }

    }, {
        State: CompanyState
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/settings/CompanySettings.js